module.exports = __webpack_public_path__ + "static/media/spacestation.3c57b3db.jpg";